import { System_instance3bcuv0kn0rmcj as System_instance } from './Kotlin-DateTime-library-kotlinx-datetime.mjs';
import {
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ApiVersion_MAY_2026_getInstance1jn2lakqb99ub as ApiVersion_MAY_2026_getInstance,
  ApiVersion_JULY_2026_getInstance26s1g5r9ct27x as ApiVersion_JULY_2026_getInstance,
  Clientssjxb7gh2u6y as Client,
  INetworkDataProvider2v0ql8qlip169 as INetworkDataProvider,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { InMemoryCache2v1xems7p2diw as InMemoryCache } from './Shared7Punches-infrastructure-cache.mjs';
import { ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider } from './Shared7Punches-common-base.mjs';
import { ILogger102gekz4uf4a8 as ILogger } from './Shared7Punches-infrastructure-logging.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(AuthenticationAccessor, 'AuthenticationAccessor', VOID, VOID, VOID, [0]);
initMetadataForClass(AuthenticationRepository, 'AuthenticationRepository', VOID, VOID, [AuthenticationAccessor], [0]);
initMetadataForInterface(IWebViewTokenRepository, 'IWebViewTokenRepository', VOID, VOID, VOID, [0]);
initMetadataForClass(WebViewTokenRepository, 'WebViewTokenRepository', VOID, VOID, [IWebViewTokenRepository], [0]);
initMetadataForCompanion(Companion);
initMetadataForInterface(IAuthenticationRemoteSource, 'IAuthenticationRemoteSource', VOID, VOID, VOID, [0, 2]);
initMetadataForClass(AuthenticationRemoteSource, 'AuthenticationRemoteSource', VOID, VOID, [IAuthenticationRemoteSource], [0, 2]);
initMetadataForInterface(IWebViewTokenRemoteSource, 'IWebViewTokenRemoteSource', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(WebViewTokenRemoteSource, 'WebViewTokenRemoteSource', VOID, VOID, [IWebViewTokenRemoteSource], [0]);
initMetadataForInterface(IWebViewUrlProvider, 'IWebViewUrlProvider', VOID, VOID, VOID, [1]);
initMetadataForClass(WebViewUrlService, 'WebViewUrlService', VOID, VOID, [IWebViewUrlProvider], [1, 0]);
initMetadataForInterface(IGetSecurityProfileUseCase, 'IGetSecurityProfileUseCase');
initMetadataForClass(GetSecurityProfileUseCase, 'GetSecurityProfileUseCase', VOID, VOID, [IGetSecurityProfileUseCase]);
//endregion
function AuthenticationRepository(sessionDataProvider, remoteSource, tokenLocalSource, clock) {
  clock = clock === VOID ? System_instance : clock;
  this.r8c_1 = sessionDataProvider;
  this.s8c_1 = remoteSource;
  this.t8c_1 = tokenLocalSource;
  this.u8c_1 = clock;
}
function WebViewTokenRepository(remoteSource) {
  this.v8c_1 = remoteSource;
}
function Companion() {
  Companion_instance = this;
  this.w8c_1 = ApiVersion_MAY_2026_getInstance();
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function AuthenticationRemoteSource(apiClient) {
  Companion_getInstance_0();
  this.x8c_1 = apiClient;
}
function IAuthenticationRemoteSource() {
}
function IWebViewTokenRemoteSource() {
}
function Companion_0() {
  Companion_instance_0 = this;
  this.y8c_1 = ApiVersion_JULY_2026_getInstance();
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 == null)
    new Companion_0();
  return Companion_instance_0;
}
function WebViewTokenRemoteSource(apiClient) {
  Companion_getInstance_1();
  this.z8c_1 = apiClient;
}
function get_authenticationModule() {
  _init_properties_AuthenticationModule_kt__lr1464();
  return authenticationModule;
}
var authenticationModule;
function authenticationModule$lambda($this$module) {
  _init_properties_AuthenticationModule_kt__lr1464();
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = authenticationModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(InMemoryCache), null, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = authenticationModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IAuthenticationRemoteSource), null, tmp2, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = authenticationModule$lambda$lambda_1;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_1 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Factory_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(AuthenticationAccessor), null, tmp2_0, kind_1, secondaryTypes_1);
  var factory_1 = new FactoryInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_1 = authenticationModule$lambda$lambda_2;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_2 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Factory_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(IGetSecurityProfileUseCase), null, tmp2_1, kind_2, secondaryTypes_2);
  var factory_2 = new FactoryInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_2 = authenticationModule$lambda$lambda_3;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_3 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Factory_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(IWebViewTokenRemoteSource), null, tmp2_2, kind_3, secondaryTypes_3);
  var factory_3 = new FactoryInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  new KoinDefinition($this$module, factory_3);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_3 = authenticationModule$lambda$lambda_4;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_4 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_4 = Kind_Factory_getInstance();
  var secondaryTypes_4 = emptyList();
  var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(IWebViewTokenRepository), null, tmp2_3, kind_4, secondaryTypes_4);
  var factory_4 = new FactoryInstanceFactory(def_4);
  $this$module.p1c(factory_4);
  new KoinDefinition($this$module, factory_4);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = authenticationModule$lambda$lambda_5;
  var scopeQualifier_5 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_5 = Kind_Singleton_getInstance();
  var secondaryTypes_5 = emptyList();
  var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(WebViewUrlService), null, definition_0, kind_5, secondaryTypes_5);
  var factory_5 = new SingleInstanceFactory(def_5);
  $this$module.p1c(factory_5);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_5);
  }
  new KoinDefinition($this$module, factory_5);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = authenticationModule$lambda$lambda_6;
  var scopeQualifier_6 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_6 = Kind_Singleton_getInstance();
  var secondaryTypes_6 = emptyList();
  var def_6 = new BeanDefinition(scopeQualifier_6, getKClass(IWebViewUrlProvider), null, definition_1, kind_6, secondaryTypes_6);
  var factory_6 = new SingleInstanceFactory(def_6);
  $this$module.p1c(factory_6);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_6);
  }
  new KoinDefinition($this$module, factory_6);
  return Unit_instance;
}
function authenticationModule$lambda$lambda($this$single, it) {
  _init_properties_AuthenticationModule_kt__lr1464();
  return new InMemoryCache();
}
function authenticationModule$lambda$lambda_0($this$factory, it) {
  _init_properties_AuthenticationModule_kt__lr1464();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new AuthenticationRemoteSource(tmp$ret$0);
}
function authenticationModule$lambda$lambda_1($this$factory, it) {
  _init_properties_AuthenticationModule_kt__lr1464();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(IAuthenticationRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$factory.q1d(getKClass(InMemoryCache), null, null);
  return new AuthenticationRepository(tmp, tmp_0, tmp$ret$2);
}
function authenticationModule$lambda$lambda_2($this$factory, it) {
  _init_properties_AuthenticationModule_kt__lr1464();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(AuthenticationAccessor), null, null);
  return new GetSecurityProfileUseCase(tmp$ret$0);
}
function authenticationModule$lambda$lambda_3($this$factory, it) {
  _init_properties_AuthenticationModule_kt__lr1464();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new WebViewTokenRemoteSource(tmp$ret$0);
}
function authenticationModule$lambda$lambda_4($this$factory, it) {
  _init_properties_AuthenticationModule_kt__lr1464();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(IWebViewTokenRemoteSource), null, null);
  return new WebViewTokenRepository(tmp$ret$0);
}
function authenticationModule$lambda$lambda_5($this$single, it) {
  _init_properties_AuthenticationModule_kt__lr1464();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IWebViewTokenRepository), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$single.q1d(getKClass(INetworkDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$single.q1d(getKClass(ILogger), null, null);
  return new WebViewUrlService(tmp, tmp_0, tmp_1, tmp$ret$3);
}
function authenticationModule$lambda$lambda_6($this$single, it) {
  _init_properties_AuthenticationModule_kt__lr1464();
  // Inline function 'org.koin.core.scope.Scope.get' call
  return $this$single.q1d(getKClass(WebViewUrlService), null, null);
}
var properties_initialized_AuthenticationModule_kt_14h1oa;
function _init_properties_AuthenticationModule_kt__lr1464() {
  if (!properties_initialized_AuthenticationModule_kt_14h1oa) {
    properties_initialized_AuthenticationModule_kt_14h1oa = true;
    authenticationModule = module_0(VOID, authenticationModule$lambda);
  }
}
function AuthenticationAccessor() {
}
function IWebViewTokenRepository() {
}
function WebViewUrlService(webViewTokenRepository, networkDataProvider, sessionDataProvider, logger) {
  this.a8d_1 = webViewTokenRepository;
  this.b8d_1 = networkDataProvider;
  this.c8d_1 = sessionDataProvider;
  this.d8d_1 = logger;
}
function IWebViewUrlProvider() {
}
function IGetSecurityProfileUseCase() {
}
function GetSecurityProfileUseCase(authenticationAccessor) {
  this.e8d_1 = authenticationAccessor;
}
//region block: exports
export {
  get_authenticationModule as get_authenticationModuleiq2nf4mpc7rt,
  AuthenticationAccessor as AuthenticationAccessor1pcbwnji0n572,
  IWebViewUrlProvider as IWebViewUrlProvidergdo0vdjldnb1,
  IGetSecurityProfileUseCase as IGetSecurityProfileUseCase16ppcw89wixlx,
};
//endregion

